import React, { useCallback, useEffect, useMemo, useState } from "react";
import * as RB from "react-bootstrap";
import DataTable from "react-data-table-component";
import FilterComponent from "../FilterComponent";
import Swal from "sweetalert2";
import EditIcon from "@mui/icons-material/Edit";
import { Delete, Visibility, Download } from "@mui/icons-material";
import * as utils from "../../Utils/comman";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { fetchUserProfile } from "../../reducers/userProfileSlice";
import "../../assets/scss/styles/TargetSales.css";
import { Icon } from "@mui/material";

function HrYearList(props) {
  const [mboList, setMboList] = useState([]);
  const [page, setPage] = useState(1);
  const dispatch = useDispatch();
  const countPerPage = 10;

  const currentYear = new Date().getFullYear();
  const [selectedYear, setSelectedYear] = useState(currentYear);
  const availableYears = [currentYear, currentYear - 1, currentYear - 2];
  const primaryMenuRes = useSelector(
    (state) => state?.primaryMenu?.primaryMenu?.permissions
  );
  const userProfile = useSelector((state) => state?.userProfile?.userProfile);

  useEffect(() => {
    if (!userProfile) {
      dispatch(fetchUserProfile());
    }
  }, [userProfile]);

  useEffect(() => {
    getMboList(currentYear);
  }, [userProfile?.id]);

  const handleFilter = () => {
    // When "Find" button is clicked, use the selected year for the API call
    getMboList(selectedYear);
  };

  const handleReset = () => {
    // When "Reset" button is clicked, reset to current year for the API call
    setSelectedYear(currentYear);
    getMboList(currentYear); // Call API with current year
  };

  const getMboList = (year) => {
    var bodyFormData = new FormData();

    bodyFormData.append("page", page);
    bodyFormData.append("per_page", countPerPage);

    utils
      .callAPI("get", `/sales/gettargetdetailsAdmin?year=${year}`, bodyFormData)
      .then((res) => {
        if (typeof res !== "undefined") {
          setMboList(res);
        } else {
          setMboList([]);
        }
      })
      .catch((err) => {
        setMboList([]);
      });
  };

  const handleView = useCallback((row) => async () => {
    const propdata = {
      mode: "HrMboView",
      rowData: row,
      year: selectedYear,
    };
    props.onChange(propdata);
  });

  const handleDownload = () => {
    const year = selectedYear; // Get the selected year
    const userId = userProfile?.id; // Assuming you want to download for the logged-in user

    const downloadUrl =
      process.env.REACT_APP_API_URL +
      `/sales/downloadexlList?year=${year}&id=${userId}`;

    // Open the URL in a new tab to trigger the download
    window.open(downloadUrl, "_blank");
  };

  const handleYearChange = (e) => {
    setSelectedYear(e.target.value);
  };

  return (
    <div className="section-body">
      <RB.Card className="card shadow ">
        <RB.Card.Header>
          <div className="">
            <RB.Form.Select
              value={selectedYear}
              onChange={handleYearChange}
              className="d-inline w-auto ms-2" // Make dropdown inline with heading
            >
              {availableYears.map((year) => (
                <option key={year} value={year}>
                  {year}
                </option>
              ))}
            </RB.Form.Select>

            <RB.Button
              className="ms-2"
              variant="primary"
              onClick={handleFilter}
            >
              Find
            </RB.Button>
            <RB.Button
              className="ms-2 mt-2 mt-md-0"
              variant="secondary"
              onClick={handleReset}
            >
              Reset
            </RB.Button>
          </div>
          <div className="card-header-action mt-2 mt-md-0">
            <RB.Button
              className="btn btn-outline-dark ms-2"
              onClick={handleDownload}
            >
              Download Excel
            </RB.Button>
          </div>
        </RB.Card.Header>
        <RB.Card.Body>
          {mboList.map((row, index) => (
            <div className={"table-responsive p-0 "}>
              <RB.Table
                bordered
                hover
                striped
                className="border mb-4 table-sm table-invoice-products"
              >
                <thead>
                  <tr>
                    <th className="text-start" colSpan={35}>
                      {row.name}
                    </th>
                  </tr>
                  <tr>
                    <th className="text-center" rowSpan={2}>
                      Sr. No.
                    </th>
                    <th className="text-center" rowSpan={2}>
                      Empl ID
                    </th>
                    <th className="text-center" rowSpan={2}>
                      Name
                    </th>
                    <th className="text-center" rowSpan={2}>
                      Designation
                    </th>
                    <th className="text-center" rowSpan={2}>
                      Location
                    </th>
                    <th className="text-center" rowSpan={2}>
                      Reporting Manager
                    </th>
                    <th className="text-center" rowSpan={2}>
                      Joining Date
                    </th>
                    <th colSpan={6} className={"text-center"}>
                      Quarter-1
                    </th>
                    <th colSpan={6} className={"text-center"}>
                      Quarter-2
                    </th>
                    <th colSpan={6} className={"text-center"}>
                      Quarter-3
                    </th>
                    <th colSpan={6} className={"text-center"}>
                      Quarter-4
                    </th>

                    {/* Total Target */}
                    <th className="text-center" rowSpan={2}>
                      Total <br /> Target
                    </th>

                    {/* Total Achi. */}
                    <th className="text-center" rowSpan={2}>
                      Total <br /> Achi.
                    </th>

                    {/* Total Shortfall */}
                    <th className="text-center" rowSpan={2}>
                      Shortfall
                    </th>

                    {/* View Button */}
                    <th className="text-center" rowSpan={2}>
                      View
                    </th>
                  </tr>
                  <tr>
                    <th className={"text-center"}>Target</th>
                    <th className={"text-center"}>Jan.</th>
                    <th className={"text-center"}>Feb.</th>
                    <th className={"text-center"}>March</th>
                    <th className={"text-center"}>Achi.</th>
                    <th className={"text-center"}>Shortfall</th>

                    <th className={"text-center"}>Target</th>
                    <th className={"text-center"}>Apr.</th>
                    <th className={"text-center"}>May</th>
                    <th className={"text-center"}>Jun.</th>
                    <th className={"text-center"}>Achi.</th>
                    <th className={"text-center"}>Shortfall</th>

                    <th className={"text-center"}>Target</th>
                    <th className={"text-center"}>Jul.</th>
                    <th className={"text-center"}>Aug.</th>
                    <th className={"text-center"}>Sep.</th>
                    <th className={"text-center"}>Achi.</th>
                    <th className={"text-center"}>Shortfall</th>

                    <th className={"text-center"}>Target</th>
                    <th className={"text-center"}>Oct.</th>
                    <th className={"text-center"}>Nov.</th>
                    <th className={"text-center"}>Dec.</th>
                    <th className={"text-center"}>Achi.</th>
                    <th className={"text-center"}>Shortfall</th>
                  </tr>
                </thead>

                <tbody className="">
                  {row.employees.map((employee, index) => (
                    <tr key={index} className="text-center">
                      <td>{employee.sr_no}</td>
                      <td>{employee.employeeId}</td>
                      <td className="">{employee.name}</td>
                      <td>{employee.designation}</td>
                      <td>{employee.location}</td>
                      <td>{employee.reporting_manager}</td>
                      <td>
                        {moment(employee.joining_date).format("D/M/YYYY")}
                      </td>
                      <td className={"text-end"}>
                        {employee.quarter_1.target}
                      </td>
                      <td className={"text-end"}>
                        {employee.quarter_1.months["Jan."]}
                      </td>
                      <td className={"text-end"}>
                        {employee.quarter_1.months["Feb."]}
                      </td>
                      <td className={"text-end"}>
                        {employee.quarter_1.months["March"]}
                      </td>
                      <td className={"text-end"}>{employee.quarter_1.total}</td>
                      <td className={"text-end"} style={{ color: "red" }}>
                        {employee.quarter_1.shortfall}
                      </td>

                      <td className={"text-end"}>
                        {employee.quarter_2.target}
                      </td>
                      <td className={"text-end"}>
                        {employee.quarter_2.months["Apr."]}
                      </td>
                      <td className={"text-end"}>
                        {employee.quarter_2.months["May"]}
                      </td>
                      <td className={"text-end"}>
                        {employee.quarter_2.months["Jun."]}
                      </td>
                      <td className={"text-end"}>{employee.quarter_2.total}</td>
                      <td className={"text-end"} style={{ color: "red" }}>
                        {employee.quarter_2.shortfall}
                      </td>

                      {/* Quarter 3 Details */}

                      <td className={"text-end"}>
                        {employee.quarter_3.target}
                      </td>
                      <td className={"text-end"}>
                        {employee.quarter_3.months["Jul."]}
                      </td>
                      <td className={"text-end"}>
                        {employee.quarter_3.months["Aug."]}
                      </td>
                      <td className={"text-end"}>
                        {employee.quarter_3.months["Sep."]}
                      </td>
                      <td className={"text-end"}>{employee.quarter_3.total}</td>
                      <td className={"text-end"} style={{ color: "red" }}>
                        {employee.quarter_3.shortfall}
                      </td>

                      <td className={"text-end"}>
                        {employee.quarter_4.target}
                      </td>
                      <td className={"text-end"}>
                        {employee.quarter_4.months["Oct."]}
                      </td>
                      <td className={"text-end"}>
                        {employee.quarter_4.months["Nov."]}
                      </td>
                      <td className={"text-end"}>
                        {employee.quarter_4.months["Dec."]}
                      </td>
                      <td className={"text-end"}>{employee.quarter_4.total}</td>
                      <td className={"text-end"} style={{ color: "red" }}>
                        {employee.quarter_4.shortfall}
                      </td>

                      {/* Total Target (Sum of all quarters) */}
                      <td>{employee.total_quarter_shortfall}</td>

                      {/* Total Achi. */}
                      <td>{employee.total_quarter_achieved}</td>

                      {/* Total Shortfall */}
                      <td>
                        <span style={{ color: "red" }}>
                          {employee.total_quarter_shortfall}
                        </span>
                      </td>

                      {/* View Button */}
                      <td>
                        <RB.Button
                          className="btn-circle"
                          variant="outline-primary"
                          size="sm"
                          onClick={handleView(employee)}
                        >
                          <Visibility />
                        </RB.Button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </RB.Table>
            </div>
          ))}
        </RB.Card.Body>
      </RB.Card>
    </div>
  );
}

export default HrYearList;
